import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20.998 6.018c.26 0 .51.1.71.29.39.39.39 1.02 0 1.41l-8.28 8.29 8.28 8.29a.996.996 0 1 1-1.41 1.41l-8.98-8.99a.996.996 0 0 1 0-1.41l8.98-8.99c.19-.2.45-.3.7-.3" }, null, -1)
  ]))]))
}
export default { render: render }